import { useState } from 'react';
import { Select } from 'antd';
import { useBreakpoint } from '@/shared/lib/hooks';
import { PickerSheet } from '@/shared/ui/inputs';
import { useListCounterpartiesQuery } from '../api/counterpartyApi';

export interface CounterpartyMultiSelectProps {
  value: string[];
  onChange: (ids: string[]) => void;
  placeholder?: string;
}

/** §12.3: фильтр списка по нескольким контрагентам сразу. Подписи выбранных берутся из полного
 *  списка, а не из результата поиска — иначе при наборе текста выбранные превращались бы в
 *  технические идентификаторы. */
export function CounterpartyMultiSelect({ value, onChange, placeholder = 'Контрагент' }: CounterpartyMultiSelectProps) {
  const [q, setQ] = useState('');
  // Телефон: выбор нескольких — в нижнем листе с поиском и галочками вместо выпадающего списка.
  const { isMobile } = useBreakpoint();
  const [sheetOpen, setSheetOpen] = useState(false);
  const { data: all = [] } = useListCounterpartiesQuery();
  const { data: found = [], isFetching } = useListCounterpartiesQuery({ q: q || undefined });

  const selected = all.filter((c) => value.includes(c.id));
  const options = [...selected, ...found.filter((c) => !value.includes(c.id))].map((c) => ({ value: c.id, label: c.name }));

  if (isMobile) {
    const closeSheet = () => {
      setSheetOpen(false);
      setQ('');
    };
    return (
      <>
        <Select<string[]>
          mode="multiple"
          allowClear
          maxTagCount="responsive"
          placeholder={placeholder}
          style={{ width: '100%' }}
          value={value}
          options={options}
          onChange={(ids) => onChange(ids)}
          open={false}
          onOpenChange={(next) => {
            if (next) setSheetOpen(true);
          }}
        />
        <PickerSheet
          open={sheetOpen}
          onClose={closeSheet}
          title={placeholder}
          mode="multiple"
          items={options.map((o) => ({ value: o.value, label: o.label }))}
          selected={value}
          search={{ value: q, onChange: setQ, placeholder: 'Поиск по названию' }}
          loading={isFetching}
          emptyText="Никого не найдено"
          onPick={(id) => onChange(value.includes(id) ? value.filter((v) => v !== id) : [...value, id])}
        />
      </>
    );
  }

  return (
    <Select<string[]>
      size="small"
      mode="multiple"
      allowClear
      showSearch
      filterOption={false}
      maxTagCount="responsive"
      loading={isFetching}
      placeholder={placeholder}
      style={{ width: '100%' }}
      value={value}
      options={options}
      onSearch={setQ}
      onChange={(ids) => {
        setQ('');
        onChange(ids);
      }}
    />
  );
}
